/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react"
import styled from "styled-components"

import Role from "./Role"
import Title from "@/containers/MoneyFortune/View/decorate/Title"
import PanelGetNFT from "./PanelGetNFT"
import PanelShare from "./PanelShare"
import Link from "next/link"
import BackBtn from "../questions/BackBtn"

export default function BBlock({
  img,
  setShowPanel,
  setPanelContent,
  roleID,
  type,
  resultImg,
  reset,
  API,
  GetAndShare,
  phone,
  setPhone,
  setAnswerInfoHandler,
  saveAnswerInfoToAPI,
  showPanel,
  getTraitId
}) {
  const [showResult, setShowResult] = useState(false)
  const [walletIdToken, setWalletIdToken] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [receiveErrorCode, setReceiveErrorCode] = useState(null)
  const [txHash, setTxHash] = useState(null)

  useEffect(() => {
    if (typeof window !== undefined && window?.kryptogo_wallet?.id_token) {
      setWalletIdToken(window?.kryptogo_wallet?.id_token)
    }
  }, [])

  const handleClick =
    role =>
    async (walletIdToken, phoneNumber = null) => {
      const phone_number = phoneNumber?.toString().startsWith("8860")
        ? `+886${phoneNumber.slice(4)}`
        : `+${phoneNumber}`
      const fetchBody = {
        event_id: API,
        trait_id: getTraitId(roleID),

        ...(!walletIdToken && { phone_number })
      }
      setAnswerInfoHandler()

      !walletIdToken && setShowPanel("send")
      setTimeout(() => {
        setShowPanel("loading")
      }, 2000)
      setIsLoading(true)

      try {
        const response = await fetch(
          `${process.env.NEXT_PUBLIC_BACKEND_BASEURL}/airdrop/receive`,
          {
            method: "POST",
            body: JSON.stringify(fetchBody),
            ...(walletIdToken && {
              headers: new Headers({
                "KG-WALLET-TOKEN": walletIdToken
              })
            })
          }
        ).then(res => res.json())
        setIsLoading(false)
        if (response?.code === 0 || response?.code === 4006)
          setTxHash(response?.data.tx_hash)
        if (response?.code !== 0) setReceiveErrorCode(response?.code)
        if (response?.code === 0) setReceiveErrorCode(null)
      } catch (error) {
        setIsLoading(false)
        setReceiveErrorCode(error?.response?.code)
      }
      setTimeout(() => {
        setShowPanel("result")
      }, 3000)
      setShowResult(true)
    }

  useEffect(() => {
    if (
      showPanel === "result" &&
      (!receiveErrorCode || receiveErrorCode === 4006)
    ) {
      saveAnswerInfoToAPI()
    }
  }, [showPanel])

  const swichToShare = () => {
    setShowPanel("close")
    setTimeout(() => {
      setShowPanel("open")
      setPanelContent(
        <PanelShare
          roleID={roleID}
          resultImg={resultImg}
          GetAndShare={GetAndShare}
        />
      )
    }, 600)
  }

  const PanelGetNFTHandler = (
    <PanelGetNFT
      setShowPanel={setShowPanel}
      showResult={showResult}
      setShowResult={setShowResult}
      isLoading={isLoading}
      receiveErrorCode={receiveErrorCode}
      handleClick={handleClick(roleID)}
      txHash={txHash}
      swichToShare={swichToShare}
      walletIdToken={walletIdToken}
      savePhoneNumber={phone}
      setSavePhoneNumber={setPhone}
      GetAndShare={GetAndShare}
      setAnswerInfoHandler={setAnswerInfoHandler}
    />
  )
  useEffect(() => {
    if (type !== "share") {
      setPanelContent(PanelGetNFTHandler)
      setAnswerInfoHandler()
    }
  }, [showResult])

  return (
    <Wrapper>
      <RoleWrapper className="RoleWrapper">
        <Role img={img} />
      </RoleWrapper>
      <BottomWrapper className="BottomWrapper">
        {type === "share" ? (
          <Link href="/money-fortune" passHref legacyBehavior>
            <GetNFTButton>
              <h3>立即測驗 領取NFT</h3>
            </GetNFTButton>
          </Link>
        ) : (
          <>
            <LeftWrapper>
              <BackBtnWrapperDesktop>
                <BackBtn content="重新測驗" onClick={reset} />
              </BackBtnWrapperDesktop>
              {GetAndShare.resultToUrl !== null ? (
                <Awrapper href={GetAndShare.resultToUrl} target="blank">
                  <GetNFTButton
                    onClick={() => {
                      setAnswerInfoHandler()
                      saveAnswerInfoToAPI()
                    }}
                  >
                    <h3>領取人物 NFT</h3>
                  </GetNFTButton>
                </Awrapper>
              ) : (
                <GetNFTButton
                  onClick={
                    walletIdToken
                      ? () => handleClick(roleID)(walletIdToken)
                      : () => {
                          setShowPanel("open")
                          setPanelContent(PanelGetNFTHandler)
                        }
                  }
                >
                  <h3>領取人物 NFT</h3>
                </GetNFTButton>
              )}
            </LeftWrapper>
            <RightWrapper>
              <Title
                title2="分享給朋友"
                type="question"
                onClick={() => {
                  setShowPanel("open")
                  setPanelContent(
                    <PanelShare
                      roleID={roleID}
                      resultImg={resultImg}
                      GetAndShare={GetAndShare}
                    />
                  )
                }}
              />
              <BackBtnWrapperMobile onClick={reset}>
                重新測驗
              </BackBtnWrapperMobile>
            </RightWrapper>
          </>
        )}
      </BottomWrapper>
    </Wrapper>
  )
}
const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  position: relative;
`

const RoleWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  transform: translate(-50%, -50%);
  @media (max-width: 1200px) {
    display: none;
  }
`
const BottomWrapper = styled.div`
  display: flex;
  width: 100%;
  z-index: 3;
  gap: 20px;
  min-height: 80px;

  @media (max-width: 1200px) {
    flex-direction: column;
  }
`
const LeftWrapper = styled.div`
  flex: 1;
  display: flex;
  position: relative;
  gap: 20px;
`

const GetNFTButton = styled.div`
  cursor: pointer;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  border: 3px solid #00fff0;
  border-radius: 12px;
  background-color: rgba(0, 0, 0, 0.9);
  padding: 16px 0;
  box-shadow: 0 0 1px #00fff0;
  animation: GetButton 2s infinite;
  will-change: transform;
  z-index: 30;
  h3 {
    margin: 0;
    font-size: 24px;
    text-align: center;
    color: #00fff0;
    text-shadow: 0 0 12px #00fff0;
  }
  @media (max-width: 1200px) {
    animation: GetButtonMobile 2s infinite;
    bottom: 30px;
    left: 50%;
    transform: translate(-50%);
    position: fixed;
    max-width: 720px;
    width: calc(100% - 40px);
    @media (max-width: 768px) {
      max-width: 410px;
    }
  }
  @keyframes GetButton {
    30% {
      box-shadow: 0 0 30px #00ffee95;
    }
    50% {
      transform: translate(0, -4px) scale(1.02);
    }
  }
  @keyframes GetButtonMobile {
    30% {
      box-shadow: 0 0 30px #00ffee95;
    }
  }
`
const BackBtnWrapperDesktop = styled.div`
  position: absolute;
  width: auto;
  height: 100px;
  top: -80px;
  left: 0;
  @media (max-width: 1200px) {
    display: none;
  }
`
const RightWrapper = styled.div`
  display: flex;
  cursor: pointer;
  gap: 20px;
  @media (max-width: 1200px) {
    order: 1;
    padding-bottom: 100px;
  }
`
const BackBtnWrapperMobile = styled.div`
  flex: 1 1 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #00fff0;
  color: #00fff0;
  &:hover {
    background-color: #00fff0;
    color: #000;
  }
  @media (min-width: 1200px) {
    display: none;
  }
`
const Awrapper = styled.a`
  width: 100%;
  display: flex;
`
